import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import doc from '../documentation.js';

const GITHUB = 'https://github.com/vimond/vimond-core-components/blob/master/src/components/';

const Example = ({ children, className, title, ...rest }) => {
  const tag = title && title.replace(/[A-Z]/g, (match, index) => `${index > 0 ? '-' : ''}${match.toLowerCase()}`);
  const docs = <div className="docs" dangerouslySetInnerHTML={{ __html: (doc[tag] && doc[tag].docs) || 'TODO: Add documentation' }}/>; // eslint-disable-line react/no-danger

  return (
    <div className={cx(`page ${tag}-example`, className)} {...rest}>
      <h2>{title}</h2>
      {children}
      <section className="documentation">
        <h3>Documentation</h3>
        {docs}
      </section>
      <section className="see-source">
        <h3>Source codes on GitHub</h3>
        <a href={`${GITHUB}${title}/${title}.jsx`}><code>{title}.jsx</code></a>
        <a href={`${GITHUB}${title}/${tag}.scss`}><code>{tag}.scss</code></a>
      </section>
      <div className="code-example">
        <a href={`${GITHUB}${title}/${title}Example.jsx`}><code>Code example</code></a>
      </div>
    </div>
  );
};

Example.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default Example;
